/* import __COLOCATED_TEMPLATE__ from './line-type.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { PROVIDERS, type Provider } from '../constants';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    provider: Provider;
    onProviderSelected: (provider: Provider) => void;
  };
}

export default class LineType extends Component<Signature> {
  get provider() {
    return this.args.provider;
  }

  get isIntercom() {
    return this.provider === PROVIDERS.INTERCOM;
  }

  get isExternal() {
    return this.provider === PROVIDERS.EXTERNAL;
  }

  get PROVIDER_TYPES() {
    return PROVIDERS;
  }

  @action
  setProvider(provider: Provider) {
    this.args.onProviderSelected(provider);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Deploy::Voice::Provisioning::LineType': typeof LineType;
  }
}
